import {
    ALERT_DIALOG_SHOW,
    ALERT_DIALOG_HIDE,
    CONFIRM_DIALOG_SHOW,
    CONFIRM_DIALOG_HIDE
} from "../actions/common-actions";


const initialState = {
    alertDialog: {
        isOpen: false,
        title: "",
        message: "",
        okHandler: () => {
        }
    },
    confirmDialog: {
        isOpen: false,
        title: "",
        message: "",
        yesHandler: () => {
        },
        noHandler: () => {
        }
    }

};

export const dialog = (state = initialState, action) => {
    switch (action.type) {
        case ALERT_DIALOG_SHOW:
            return {
                ...state,
                alertDialog: {...action.options, isOpen: true}
            }
        case ALERT_DIALOG_HIDE:
            return {
                ...state,
                alertDialog: {isOpen: false}
            }
        case CONFIRM_DIALOG_SHOW:
            return {
                ...state,
                confirmDialog: {...action.options, isOpen: true}
            }
        case CONFIRM_DIALOG_HIDE:
            return {
                ...state,
                confirmDialog: {isOpen: false}
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/common/reducers/dialog-reducer.js